export const grabAndGo = {
	searchPlaceholder: "Filter products",
	activeProducts: "Active products for Grab and Go",
	disabledProducts: "Deactivated products for Grab and Go",
};
